import React from 'react';
import PropTypes from 'prop-types';

// Progress bar
const Progress = ({ stageNumber }) => {
  if (stageNumber >= 12) return null;

  return (
    <div className={`progress__stageBar w-${stageNumber}`}>
      {stageNumber === 6 && <div className="halfway">Halfway there!</div>}
      {stageNumber === 9 && <div className="nearly">Nearly there!</div>}

      <div className="stage-number">{stageNumber}/11</div>
    </div>
  );
};

Progress.propTypes = {
  stageNumber: PropTypes.number,
};

export default Progress;
